module.exports = __webpack_public_path__ + "img/ffd71ed.jpg";